import Moment from 'moment';
import { extendMoment } from 'moment-range';

const moment = extendMoment(Moment);

const getMaxUnits = (
  seatsLeft,
  initialValues,
  availableUnitsData,
  bookRentalItemsForm
) => {
  if (
    !initialValues ||
    !bookRentalItemsForm ||
    !availableUnitsData?.values
  ) {
    
    return seatsLeft;
  }

  const currentValues = availableUnitsData.values;
  
  let currentStart, currentEnd;
  
  if (currentValues.multiDates && currentValues.multiDates.startDate && currentValues.multiDates.endDate) {
    currentStart = moment(currentValues.multiDates.startDate);
    currentEnd = moment(currentValues.multiDates.endDate);
  } else if (currentValues.startingDate) {
    currentStart = moment(currentValues.startingDate);
    currentEnd = moment(currentValues.startingDate);
  } else {
    
    return seatsLeft;
  }
  
  let initialStart, initialEnd;
  
  if (initialValues.multiDates && initialValues.multiDates.startDate && initialValues.multiDates.endDate) {
    initialStart = moment(initialValues.multiDates.startDate);
    initialEnd = moment(initialValues.multiDates.endDate);
  } else if (initialValues.startingDate) {
    initialStart = moment(initialValues.startingDate);
    initialEnd = moment(initialValues.startingDate);
  } else {
  
    return seatsLeft;
  }
  
  // Check if the dates are the same (user is updating the same booking)
  if (
    currentStart && currentEnd && initialStart && initialEnd &&
    initialStart.isSame(currentStart, 'day') &&
    initialEnd.isSame(currentEnd, 'day')
  ) {
    const rentalItems = bookRentalItemsForm.rentalItems;
    
    if (rentalItems && rentalItems.length) {
      const availableUnitsPerDate = rentalItems[0].availableUnitsPerDate || [];
      
      let minAvailableInRange = null;
      const startDate = moment(currentStart).format('YYYY-MM-DD');
      const endDate = currentEnd === null ? currentStart : moment(currentEnd).format('YYYY-MM-DD');
      
      
      // Find the minimum available units in the date range
      availableUnitsPerDate.forEach(item => {
        
        const itemDate = moment(item.date, 'YYYY-MM-DD');
        if (itemDate.isBetween(startDate, endDate, 'days', '[]') || itemDate.isSame(startDate, endDate, 'day', '[]')) {
          if (minAvailableInRange === null || item.availableUnits < minAvailableInRange) {
            minAvailableInRange = item.availableUnits;
          }
        }
      });

      if (minAvailableInRange !== null) {
        // Calculate how many units were originally booked
        const numberOfBookedUnits = initialValues.availableUnits.reduce(
          (accumulator, availableUnit) => {

            const units = parseInt(availableUnit.unitsNumber || availableUnit.availableUnits) || 0;
            return accumulator + units;
          },
          0
        );
        
       
        
        return minAvailableInRange + numberOfBookedUnits;
      }
    }
  } 
  
 
  return seatsLeft;
};
const getMaxUnitsRentalItemsSeveralDays = (
  availableUnitsPerDate,
  startDate,
  endDate,
  bookedData
) => {
  let availableUnits = null;

  availableUnitsPerDate.forEach(item => {
    const itemDate = moment(item.date, 'YYYY-MM-DD');
    if (itemDate.isBetween(startDate, endDate, 'days', '[]')) {
      if (availableUnits !== null) {
        if (availableUnits > item.availableUnits) {
          availableUnits = item.availableUnits;
        }
      } else {
        availableUnits = item.availableUnits;
      }
    }
  });

  if (bookedData && bookedData.multiDates) {
    const bookedRange = moment.range(
      bookedData.multiDates.startDate,
      bookedData.multiDates.endDate
    );

    const selectedRange = moment.range(
      moment(moment(startDate).format('DD/MM/YYYY'), 'DD/MM/YYYY'),
      moment(moment(endDate).format('DD/MM/YYYY'), 'DD/MM/YYYY')
    );

    const overlaps = selectedRange.overlaps(bookedRange, { adjacent: true });

    const bookedPlaces = bookedData.availableUnits.reduce(
      (acc, obj) => acc + parseInt(obj.availableUnits || 0),
      0
    );

    if (overlaps) {
      if (!availableUnits) availableUnits = 0;
      return availableUnits + bookedPlaces;
    }
  }

  return availableUnits;
};

const getMaxUnitsRentalItemsHourly = (
  availableUnitsPerDate,
  startDate,
  endDate,
  bookedData,
  startTime,
  endTime,
  isUpdating = false
) => {
  if (!availableUnitsPerDate || !startDate || !startTime || !endTime) {
    return null;
  }

  

  // Parse requested range
  const startMoment = moment.isMoment(startDate) ? startDate : moment(startDate);
  const endMoment = endDate ? (moment.isMoment(endDate) ? endDate : moment(endDate)) : startMoment;

  // Parse times more robustly
  const parseTime = (timeStr) => {
    if (moment.isMoment(timeStr)) return timeStr;
    const cleaned = String(timeStr).split(/[+-]/)[0];
    return moment(cleaned, ["HH:mm:ss", "HH:mm"]);
  };

  const startHour = parseTime(startTime);
  const endHour = parseTime(endTime);

  let requestedStart = startMoment.clone().set({
    hour: startHour.hour(),
    minute: startHour.minute(),
    second: 0,
    millisecond: 0
  });

  let requestedEnd = endMoment.clone().set({
    hour: endHour.hour(),
    minute: endHour.minute(),
    second: 0,
    millisecond: 0
  });

  if (requestedEnd.isSameOrBefore(requestedStart)) {
    requestedEnd.add(1, "day");
  }

 

  const overlappingBlocks = availableUnitsPerDate.filter(block => {
    if (!block.startTime || !block.endTime) return false;
    
    const blockStart = moment(block.startTime);
    const blockEnd = moment(block.endTime);
    
    const overlaps = requestedStart.isBefore(blockEnd) && blockStart.isBefore(requestedEnd);
    
    if (overlaps) {
      
    }
    
    return overlaps;
  });

  if (!overlappingBlocks.length) {

    return 0;
  }

  const minAvailable = Math.min(
    ...overlappingBlocks.map(b => Number(b.availableUnits ?? 0))
  );



  const calculateBookedUnits = (bd) => {
    if (!bd) return 0;
    
    if (Array.isArray(bd.availableUnits)) {
      return bd.availableUnits.reduce((acc, obj) => {
        return acc + Number(obj.availableUnits ?? obj.unitsNumber ?? 0);
      }, 0);
    }
    
    if (typeof bd.unitsNumber !== "undefined") {
      return Number(bd.unitsNumber);
    }
    
    return Number(bd.availableUnits ?? 0);
  };

  let bookedUnits = 0;
  let currentBookingUnits = 0;

  if (bookedData) {
    const bookings = Array.isArray(bookedData) ? bookedData : [bookedData];

    bookings.forEach((bd) => {
      if (!bd?.startingDate || !bd?.startTime || !bd?.endTime) {
        return;
      }

      const bdStartDate = moment.isMoment(bd.startingDate) 
        ? bd.startingDate 
        : moment(bd.startingDate);
      
      const bdEndDate = bd.multiDates?.endDate 
        ? moment(bd.multiDates.endDate) 
        : bdStartDate.clone();

      const bdStartHour = parseTime(bd.startTime);
      const bdEndHour = parseTime(bd.endTime);

      const bookedStart = bdStartDate.clone().set({
        hour: bdStartHour.hour(),
        minute: bdStartHour.minute(),
        second: 0,
        millisecond: 0
      });

      const bookedEnd = bdEndDate.clone().set({
        hour: bdEndHour.hour(),
        minute: bdEndHour.minute(),
        second: 0,
        millisecond: 0
      });

      if (bookedEnd.isSameOrBefore(bookedStart)) {
        bookedEnd.add(1, "day");
      }

      const overlaps = requestedStart.isBefore(bookedEnd) && 
                      bookedStart.isBefore(requestedEnd);

      if (overlaps) {
        const units = calculateBookedUnits(bd);
        
        // Check if this is the EXACT same booking being updated
        const isSameTimeSlot = isUpdating &&
          bookedStart.isSame(requestedStart) && 
          bookedEnd.isSame(requestedEnd) &&
          bdStartDate.isSame(startMoment, 'day');
        
        if (isSameTimeSlot) {
          currentBookingUnits = units;
          
        } else {
          bookedUnits += units;
         
        }
      }
    });
  }

  const availableSlots = isUpdating 
    ? Math.max(0, minAvailable - bookedUnits + currentBookingUnits)
    : Math.max(0, minAvailable - bookedUnits);

 

  return availableSlots;
};


const getBookedUnitsHourly = (
  bookedData,
  requestedStartDate,
  requestedEndDate,
  requestedStartTime,
  requestedEndTime
) => {


  if (
    !bookedData?.startingDate ||
    !bookedData?.startTime ||
    !bookedData?.endTime
  ) {
    return 0;
  }

  // Convert request start/end to full datetime
  const reqStart = moment(requestedStartDate)
    .set({
      hour: moment(requestedStartTime, "HH:mm:ss").hour(),
      minute: moment(requestedStartTime, "HH:mm:ss").minute(),
      second: 0,
    });

  const reqEnd = moment(requestedEndDate)
    .set({
      hour: moment(requestedEndTime, "HH:mm:ss").hour(),
      minute: moment(requestedEndTime, "HH:mm:ss").minute(),
      second: 0,
    });

  // Convert booking data
  const bookedStartDate = moment(bookedData.startingDate);
  const bookedEndDate = bookedData?.multiDates?.endDate
    ? moment(bookedData.multiDates.endDate)
    : bookedStartDate.clone();

  const bookedStartTime = moment(bookedData.startTime.split(/[+-]/)[0], "HH:mm:ss");
  const bookedEndTime = moment(bookedData.endTime.split(/[+-]/)[0], "HH:mm:ss");

  const bookedStart = bookedStartDate.clone().set({
    hour: bookedStartTime.hour(),
    minute: bookedStartTime.minute(),
    second: 0,
  });

  const bookedEnd = bookedEndDate.clone().set({
    hour: bookedEndTime.hour(),
    minute: bookedEndTime.minute(),
    second: 0,
  });

  if (bookedEnd.isSameOrBefore(bookedStart)) {
    bookedEnd.add(1, "day");
  }

  const overlap =
    reqStart.isBefore(bookedEnd) && bookedStart.isBefore(reqEnd);

  if (overlap) {
    const bookedUnits =
      Array.isArray(bookedData.availableUnits)
        ? bookedData.availableUnits.reduce(
            (sum, unit) => sum + Number(unit.availableUnits || 0),
            0
          )
        : 0;


    return bookedUnits;
  }

  return 0;
};

const getBookedUnits = (bookedData, requestedStartDate, requestedEndDate) => {
  
  if (!bookedData?.startingDate) {
    return 0;
  }
  
  const reqStart = moment(requestedStartDate).startOf("day");
  const reqEnd = moment(requestedEndDate).endOf("day");
  const bookedStart = moment(bookedData.startingDate).startOf("day");
  const bookedEnd = bookedData?.multiDates?.endDate
    ? moment(bookedData.multiDates.endDate).endOf("day")
    : bookedStart.clone().endOf("day");

  const overlap = reqStart.isBefore(bookedEnd) && bookedStart.isBefore(reqEnd);
  
  if (overlap) {
    const bookedUnits = Array.isArray(bookedData.availableUnits)
      ? bookedData.availableUnits.reduce(
          (sum, unit) => sum + Number(unit.availableUnits || 0),
          0
        )
      : Number(bookedData.availableUnits || 0);
    
    return bookedUnits;
  }
  
  return 0;
};


export {
  getMaxUnits,
  getMaxUnitsRentalItemsSeveralDays,
  getMaxUnitsRentalItemsHourly,
  getBookedUnitsHourly,
  getBookedUnits
};